




























import Vue from 'vue';

export default Vue.extend({
  props: {
    headerText: { type: String },
    opened: { type: Boolean, default: false },
    hedaerFontSize : { type: Number, default: 16 },
    topDivider: { type: Boolean, default: true },
    bottomDivider: { type: Boolean, default: true },
  },

  data() {
    return {
      visible: this.opened
    }
  }
});
